import TableContainer from "components/tables/TableContainer"
import React, { useState, useEffect } from "react"

import { Input, Modal, ModalBody, ModalHeader } from "reactstrap"

function ModalDetailRow(props) {
  const {
    selectedToAdd,
    selectedId,
    setSelectedToAdd,
    params,
    setParams,
    tempDataDetail,
  } = props
  const [trigger, setTrigger] = React.useState(false)

  const data = React.useMemo(() => {
    if (tempDataDetail) {
      return tempDataDetail
    }
    return { content: [] }
  }, [selectedId, selectedToAdd, trigger, params, tempDataDetail])

  const columns = React.useMemo(
    () => [
      {
        Header: "受注ID",
        accessor: "orderNumber",
        defaultCanSort: false,
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        defaultCanSort: false,
      },
      {
        Header: "用尺",
        accessor: "scale",
        defaultCanSort: false,
      },
      {
        Header: "発注ステータス",
        accessor: "orderStatus",
        defaultCanSort: false,
      },
      {
        Header: "発注ID",
        accessor: "orderInventoryNumber",
        defaultCanSort: false,
      },
      {
        Header: "選択",
        accessor: "selectable",
        defaultCanSort: false,
        Cell: ({ cell }) => {
          return (
            <Input
              type="checkbox"
              checked={cell?.row?.original?.selected || false}
              disabled={!cell.row.original.selectable}
              value={cell.row.original.selected || false}
              onClick={e => {
                const data = cell.row.original
                if (!data.selected || data.selected == "undefined") {
                  data.selected = true
                } else {
                  data.selected = false
                }
                setTrigger(!trigger)
                console.log("data")
                console.log(data)

                const temp = [...selectedToAdd]
                if (temp.length > 0) {
                  const existing = temp.find(i => i.orderId == data.orderId)
                  console.log("existing")
                  console.log(existing)
                  if (!existing) {
                    temp.push(data)
                  } else {
                    temp.forEach(t => {
                      if (t.orderId == existing.orderId) {
                        t = data
                      }
                    })
                  }
                } else {
                  temp.push(data)
                }

                setSelectedToAdd(temp)
              }}
            />
          )
        },
      },
    ],
    [selectedId, selectedToAdd, trigger, params, tempDataDetail]
  )
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="xl">
      <ModalHeader toggle={props.toggle}></ModalHeader>
      <ModalBody>
        <TableContainer
          columns={columns}
          data={data?.content}
          pagination
          page={params.page + 1}
          size={params.size}
          count={data?.totalPages || 1}
          setPageSize={size => setParams({ ...params, size })}
          setParams={page => setParams({ ...params, page: page.page })}
        />
      </ModalBody>
    </Modal>
  )
}

export default ModalDetailRow
